/* eslint-disable */
import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";
import { GridContainer, GridRow, GridColumn } from "arv-reactcomponents";
import {
  PDP_CAROUSEL_SIZE,
  PDP_CAROUSEL_DEFAULT_VIEWALL_TEXT,
} from "../../constants";

import CarouselComponent from "./CarouselComponent";
import Analytics from "../../analytics";
import Event from "../../analytics/eventFactory";
import Anchor from "../Anchor";
import { isDesktop } from "../../utils";

@inject("ProductStore")
@observer
class ProductCarousel extends Component {
  constructor() {
    super();
    this.clearProductData = this.clearProductData.bind(this);
    this.triggerGa = this.triggerGa.bind(this);
  }
  clearProductData() {
    window.scrollTo(0, 0);
    this.props.ProductStore.clearProductData();
    this.triggerGa();
  }
  triggerGa() {
    const { origin, title } = this.props;
    Analytics.trackEvent({
      category: window.pageType,
      action: Event.action.getMasterTemplateActions([
        origin,
        Event.action.PRODUCT_CAROUSEL_VIEW_ALL,
      ]),
      label: Event.label.getProperLabelWithoutSpaces(title),
    });
  }
  render() {
    const {
      title,
      list,
      viewAllLink,
      size,
      viewAllText,
      origin,
      className,
      mobileViewAllReload,
      hideTitleAndViewAllText,
    } = this.props;
    return (
      <Fragment>
        {list.length > 0 && (
          <GridContainer className={`nw-pdpcarousel ${className}`}>
              <GridRow className={`nw-pdpcarouseltitlecontainer ${className}`}>
              <div className={`nwc-grid-col nwc-grid-col-sm-3 ${className}`} />
              <GridColumn
                className={`nwc-grid-col-sm-6 nw-pdpcarouseltitlecolumn ${className}`}
              >
                <h1 className={`nw-pdpcarouseltitle ${className}`}>{title}</h1>
              </GridColumn>
              <GridColumn
                className={`nwc-grid-col-sm-3 nw-pdpcarouselviewall ${className}`}
              >
                {viewAllLink && (
                  <Anchor
                    href={viewAllLink}
                    to={viewAllLink}
                    target="_blank"
                    className={`nw-pdpcarouselviewallanchor ${className}`}
                    onClick={this.triggerGa}
                  >
                    {viewAllText}
                    <i
                      className={`icomoon-arrow_right nw-pdpcarouselviewallanchorarrow ${className}`}
                    />
                  </Anchor>
                )}
              </GridColumn>
            </GridRow>
        
            <GridRow>
              <GridColumn>
                <CarouselComponent
                  title={title}
                  list={list}
                  size={size}
                  origin={origin}
                  className={className}
                />
              </GridColumn>
            </GridRow>
            <GridRow>
              <GridColumn
                className={`nw-pdpcarouselmobileviewall ${className}`}
              >
                {viewAllLink && (
                  <Anchor
                    href={viewAllLink}
                    to={viewAllLink}
                    target={`${mobileViewAllReload ? "_self" : ""}`}
                    className={`nw-pdpcarouselmobileviewallbutton ${className}`}
                    onClick={this.clearProductData}
                  >
                    {viewAllText}
                  </Anchor>
                )}
              </GridColumn>
            </GridRow>
          </GridContainer>
        )}
      </Fragment>
    );
  }
}

ProductCarousel.defaultProps = {
  viewAllLink: "",
  size: PDP_CAROUSEL_SIZE,
  viewAllText: PDP_CAROUSEL_DEFAULT_VIEWALL_TEXT,
  origin: "",
  className: "",
  mobileViewAllReload: false,
};

ProductCarousel.propTypes = {
  mobileViewAllReload: PropTypes.bool,
  className: PropTypes.string,
  ProductStore: PropTypes.shape({
    clearProductData: PropTypes.func.isRequired,
  }).isRequired,
  list: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  title: PropTypes.string.isRequired,
  viewAllLink: PropTypes.string,
  viewAllText: PropTypes.string,
  size: PropTypes.shape({}),
  origin: PropTypes.string,
};

export default ProductCarousel;



// WEBPACK FOOTER //
// ./src/component/ProductCarousel/index.js